import { ApiClient } from 'services/api-client'
import {
	AutoRefundsFrequency,
	AutoRefundsPatch,
	ClaimNowResult,
	LaunchAgentResult,
	RefundsRange,
	RefundsResponse
} from './types'

interface ApiEnvelope<T> {
	data: T
	meta?: unknown
}

interface FetchRefundsOptions {
	adAccountId?: string | null
	range?: RefundsRange
}

export const fetchRefunds = async (
	accountId: string,
	opts: FetchRefundsOptions = {}
): Promise<RefundsResponse> => {
	const params = new URLSearchParams()
	if (opts.adAccountId) params.set('ad_account_id', opts.adAccountId)
	if (opts.range) params.set('range', opts.range)
	const qs = params.toString()
	const { data } = await ApiClient.client.get<ApiEnvelope<RefundsResponse>>(
		`accounts/${accountId}/refunds${qs ? `?${qs}` : ''}`
	)
	return data.data
}

export const launchAgent = async (
	accountId: string,
	body: { adAccountId: string; frequency: AutoRefundsFrequency }
): Promise<LaunchAgentResult> => {
	const { data } = await ApiClient.client.post<ApiEnvelope<LaunchAgentResult>>(
		`accounts/${accountId}/refunds/launch`,
		{ ad_account_id: body.adAccountId, frequency: body.frequency }
	)
	return data.data
}

export const claimNow = async (
	accountId: string,
	body: { adAccountId: string }
): Promise<ClaimNowResult> => {
	const { data } = await ApiClient.client.post<ApiEnvelope<ClaimNowResult>>(
		`accounts/${accountId}/refunds/claim-now`,
		{ ad_account_id: body.adAccountId }
	)
	return data.data
}

export const patchAutoRefunds = async (
	accountId: string,
	adAccountId: string,
	body: AutoRefundsPatch
): Promise<void> => {
	await ApiClient.client.patch(
		`accounts/${accountId}/ad-accounts/${adAccountId}/auto-refunds`,
		body
	)
}

export const markAnnouncementSeen = async (
	accountId: string,
	key = 'refunds_agent'
): Promise<void> => {
	await ApiClient.client.post('users/announcements/seen', {
		account_id: accountId,
		key
	})
}
